import React, { useState, useRef } from 'react';
import axios from 'axios';

function ImageUpload({ value, onChange, type = 'images', label, height = 80 }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  const handleFile = async (file) => {
    if (!file) return;
    setError(null);
    setUploading(true);
    try {
      const form = new FormData();
      form.append('file', file);
      const res = await axios.post(`/api/admin/upload?type=${encodeURIComponent(type)}`, form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      onChange(res.data.url);
    } catch (err) {
      setError(err.response?.data?.error || 'העלאה נכשלה');
    } finally {
      setUploading(false);
    }
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    onChange(null);
  };

  return (
    <div className="image-upload">
      {label && <label>{label}</label>}
      <div
        className="image-upload-drop"
        style={{ height: `${height}px` }}
        onClick={() => inputRef.current?.click()}
      >
        {value ? (
          <>
            <img src={value} alt="" />
            <button type="button" className="image-upload-remove" onClick={handleRemove}>×</button>
          </>
        ) : (
          <div className="image-upload-placeholder">
            {uploading ? 'מעלה...' : 'לחץ לבחירת תמונה'}
          </div>
        )}
      </div>
      {error && <div className="image-upload-error">{error}</div>}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={e => handleFile(e.target.files?.[0])}
      />
    </div>
  );
}

export default ImageUpload;
